__turbopack_context__.v({
  "buyCanadianWrapper": "Hit-module-scss-module___Wx7rW__buyCanadianWrapper",
  "dealsBannerContainer": "Hit-module-scss-module___Wx7rW__dealsBannerContainer",
  "hit": "Hit-module-scss-module___Wx7rW__hit",
  "hitImage": "Hit-module-scss-module___Wx7rW__hitImage",
  "hitImageContainer": "Hit-module-scss-module___Wx7rW__hitImageContainer",
  "hitImageLink": "Hit-module-scss-module___Wx7rW__hitImageLink",
  "hitOldPrice": "Hit-module-scss-module___Wx7rW__hitOldPrice",
  "hitPriceCustomerGroup": "Hit-module-scss-module___Wx7rW__hitPriceCustomerGroup",
  "hitPrices": "Hit-module-scss-module___Wx7rW__hitPrices",
  "hitReviewCount": "Hit-module-scss-module___Wx7rW__hitReviewCount",
  "hitReviews": "Hit-module-scss-module___Wx7rW__hitReviews",
  "hitTags": "Hit-module-scss-module___Wx7rW__hitTags",
  "hitTitle": "Hit-module-scss-module___Wx7rW__hitTitle",
  "hitTitleHighlighted": "Hit-module-scss-module___Wx7rW__hitTitleHighlighted",
});
